import { CloudWatchLogsClient, PutLogEventsCommand } from "@aws-sdk/client-cloudwatch-logs";
import consoleLogger from "../../logger/loggers/consoleLogger";
import { awsErrorTypes } from "../../../consts";
import cloudWatchTokenProvider from "./cloudWatchTokenProvider";

const region = process.env.REACT_APP_AWS_COGNITO_REGION;

let AWSClient = null;
let cloudWatchConfig = null;

const putEvents = async ({ eventMessages, onError, onComplete }) => {
  try {
    const cloudWatchClient = await getCloudWatchClient();
    const requestData = await prepareEvent(eventMessages);

    await exposeEvents({
      cloudWatchClient,
      requestData,
      onError,
      onComplete
    });
  } catch {
    onError();
  }
};

const exposeEvents = async ({ cloudWatchClient, requestData, onError, onComplete }) => {
  try {
    const command = new PutLogEventsCommand(requestData);
    const data = await cloudWatchClient.send(command);

    cloudWatchConfig.sequenceToken = data ? data.nextSequenceToken : null;
    onComplete();
  } catch (err) {
    consoleLogger.error(`cloudWatchProvider: putLogEvents error: ${err.toString()}`);

    onError();

    switch (err.name) {
      case awsErrorTypes.EXPIRED_TOKEN_EXCEPTION:
        cloudWatchConfig = null;
        break;

      default:
        break;
    }
  }
};

const getCloudWatchClient = async () => {
  if (!AWSClient || !cloudWatchConfig || cloudWatchTokenProvider.isCredentialsExpired()) {
    const credentials = await cloudWatchTokenProvider.getLoggingCredentials();

    createCloudWatchClient(credentials);
  }

  return AWSClient;
};

const createCloudWatchClient = (credentials) => {
  if (credentials && credentials.credentials && credentials.logging) {
    cloudWatchConfig = {
      groupName: credentials.logging.logGroupName,
      streamName: credentials.logging.logStreamName,
      sequenceToken: credentials.logging.uploadSequenceToken
    };

    AWSClient = new CloudWatchLogsClient({
      region: region,
      credentials: credentials.credentials,
      maxAttempts: 0
    });
  }
};

const updateCloudWatchClient = (credentials) => {
  if (AWSClient) {
    createCloudWatchClient(credentials);
  }
};

const prepareEvent = async (logEvents) => {
  const { groupName, streamName, sequenceToken } = cloudWatchConfig;

  const data = {
    logEvents: [...logEvents],
    logGroupName: groupName,
    logStreamName: streamName
  };

  if (sequenceToken) {
    data.sequenceToken = sequenceToken;
  }

  return data;
};

const cloudWatchProvider = {
  putEvents,
  updateCloudWatchClient
};

export default cloudWatchProvider;
